module.exports = __webpack_public_path__ + "./fonts/DMSans-Bold.41dc91.woff";